module.exports = __webpack_public_path__ + "static/media/change_boss.8ccb1d20.png";